import { appEntry } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1000px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0">
            <div className="w-44 h-44 md:w-52 md:h-52 rounded-2xl overflow-hidden bg-background-50 p-3 border border-background-200">
              <img
                src={appEntry.qrImage}
                alt="蚂蚁影视移动端扫码下载"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-xs text-foreground-400 text-center mt-3">扫码下载移动客户端</p>
          </div>

          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
              {appEntry.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
              {appEntry.desc}
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-3 mb-6">
              {appEntry.badges.map((badge) => (
                <span
                  key={badge}
                  className="px-3 py-1.5 rounded-lg text-xs font-medium bg-background-50 border border-background-200 text-foreground-600"
                >
                  <i className="ri-check-line mr-1 text-primary-500"></i>
                  {badge}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-3">
              <button className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </button>
              <button className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}